import React from "react";
import "../setup/App.css";

function SectionHeader(props: { title: string }) {
  return (
    <div className="content-section-heading">
      <h2
        className="mb-5"
        style={{ fontFamily: "Open Sans", fontSize: "3rem", fontWeight: 700 }}
      >
        &lt;{props.title.toUpperCase()}/&gt;
      </h2>
    </div>
  );
}

export default SectionHeader;
